// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconMap = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M10.152 7c.55-2.073 2.474-3 3.848-3s3.299.927 3.848 3H22v14H5a3 3 0 01-3-3V7a3 3 0 013-3h1.5v3zm4.61 7.647l.004-.005.008-.01.029-.033.102-.125a23 23 0 001.436-1.982c.392-.609.797-1.312 1.107-2.026.2-.461.376-.96.473-1.466H20v10H5a1 1 0 110-2h1.5V9h3.579c.097.505.272 1.005.473 1.466.31.715.715 1.417 1.107 2.026a23 23 0 001.538 2.107l.029.034.008.01.003.003zM12.586 9a1.5 1.5 0 10-.006-.019z"
    />
  );
export default SvgIconMap;
